/** Emails allowed into Maestro Ops / Admin (must match AdminLayout). */
export const ADMIN_EMAILS = ['paul@psaudio.com', 'mcgowan.paul1@gmail.com'];

export function isWhitelistedAdminEmail(email) {
  if (!email || typeof email !== 'string') return false;
  return ADMIN_EMAILS.includes(email.toLowerCase().trim());
}
